import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { firstValueFrom } from 'rxjs';
import { TokenService } from './token.service';

@Injectable({ providedIn: 'root' })
export class TokenAtualizacaoService {
    readonly refreshEmProgresso = signal(false);

    constructor(private http: HttpClient, private tokenService: TokenService) { }

    async tentarAtualizarToken(): Promise<boolean> {
        if (this.refreshEmProgresso()) return false;

        this.refreshEmProgresso.set(true);
        try {
            const res = await firstValueFrom(
                this.http.post<{ tokenAcesso: string }>(
                    `${environment.apiBaseUrl}/autenticacao/token-atualizacao`,
                    {},
                    { headers: { skipAuth: 'true' }, withCredentials: true }
                )
            );

            this.tokenService.definirSessao(res.tokenAcesso);
            return true;
        } catch {
            this.tokenService.limparSessao();
            return false;
        } finally {
            this.refreshEmProgresso.set(false);
        }
    }
}
